import React, { Component } from 'react';
import { observer } from 'mobx-react';
import AddListingTimeline from '../listing/AddListingTimeline';
import styled from 'styled-components';
import Intro from './Intro';
import Description from './Description';
import history from '../../core/history';
import saveQL from './saveQL';
import { observable } from 'mobx';
import Address from './Address';
import Price from './Price';
import Rules from './Rules';
import Availability from './Availability';
import Photos from './Photos';
import Success from './Success';
import { updateListingPhotoOrder } from './savePhotosQL';
import Review from './Review';
import { ManagePublishStatus } from './getListingQL';
import { addListingView } from '../../core/analytics';

@observer
export default class AddListingWizard extends Component {
  @observable saveError = '';
  nextPage = async (nextPage, isBack) => {
    const { listId, formBaseURI, query, store } = this.props;

    store.visit(store.currentStepName);
    if (store.currentStepName !== 'review') {
      const isValid = store.currentGroupValid;
      if (!isValid && !store.editing && !isBack) {
        return;
      }

      await store.save(saveQL);
      if (!store.listId) {
        console.log('Error saving listing');
        this.saveError = 'Failed to save listing';
      } else {
        this.saveError = '';
      }
      if (store.currentStepName === 'photos') {
        store.updateCoverPhoto(updateListingPhotoOrder);
      }
    }

    const list_id = store.listId || listId;

    // let params = `?lat=${store.lat}&lng=${store.lng}`;
    let params = `?`;
    if (store.currentStepName === 'review' || query.editing) {
      params = params + `&editing=true`;
    }
    let pathName = formBaseURI + nextPage;
    if (list_id) {
      pathName = `${formBaseURI + list_id}/${nextPage}${params}`;
    }
    addListingView(nextPage);
    history.push(pathName);

    if (nextPage === 'home') {
      store.editing = true;
    }
  };

  publish = async () => {
    const { store, formBaseURI } = this.props;

    const isValid = store.currentGroupValid;
    if (!isValid && !store.editing && !store.published) {
      return;
    }
    await store.updatePublish(ManagePublishStatus);
    if (!store.published) {
      return;
    } else {
      const pathName = `${formBaseURI + store.listId}/success?editing=true`;
      history.push(pathName);
      return;
    }
  };

  start = () => {
    const { formBaseURI, store } = this.props;
    let pathName = formBaseURI + store.timelineSteps[0];
    history.push(pathName);
  };

  render() {
    const { store, account, categories } = this.props;
    const currentPage = store.currentStepName;

    let page = (
      <Intro
        store={store}
        firstName={account && account.firstName}
        nextPage={this.start}
      />
    );
    switch (currentPage) {
      case 'description':
        page = (
          <Description
            store={store}
            nextPage={this.nextPage}
            categories={categories}
          />
        );
        break;
      case 'address':
        page = <Address store={store} nextPage={this.nextPage} />;
        break;
      case 'rules':
        page = <Rules store={store} nextPage={this.nextPage} />;
        break;
      case 'availability':
        page = <Availability store={store} nextPage={this.nextPage} />;
        break;
      case 'price':
        page = <Price store={store} nextPage={this.nextPage} />;
        break;
      case 'photos':
        page = <Photos store={store} nextPage={this.nextPage} />;
        break;
      case 'review':
        page = <Review store={store} nextPage={this.publish} />;
        break;
      case 'success':
        page = <Success store={store} />;
        break;
    }

    return (
      <div className="">
        {currentPage !== 'intro' && (
          <TimelineContainer
            className="f f-cc f-1 h-120 px-l mb-l"
            style={{ maxWidth: '1200px', margin: '0 auto' }}
          >
            <AddListingTimeline store={store} stepChanged={this.nextPage} />
          </TimelineContainer>
        )}
        {page}
        {this.saveError && <Text error>{this.saveError}</Text>}
      </div>
    );
  }
}

const TimelineContainer = styled.div`
  @media screen and (min-width: 1200px) {
    margin-right: 120px;
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/addListing/AddListingWizard.js